import {Box, Chip, Stack, Typography} from "@mui/material";
import BackButton from "./components/BackButton";
import DateText from "components/DateText";
import {useMaterialQuery} from "@generated/graphql";
import {useOutletContext, useParams} from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import Text from "components/Text";
import {MaterialContextProps} from "../types";
import {useEffect} from "react";
import FileItem from "pages/Material/view/components/FileItem";

const MaterialView = () => {
  const {setSelectedSubcategory, setSelectedCategory, setMixedFilterValue} = useOutletContext<MaterialContextProps>()
  const {id} = useParams()
  const {data, loading} = useMaterialQuery({
    variables: {
      materialId: id!
    }
  });

  const material = data?.material;

  useEffect(() => {
    if (material) {
      setSelectedCategory(material.subcategory?.category || null);
      setSelectedSubcategory(material.subcategory?.id || '');
      setMixedFilterValue(material.subcategory || null)
    }
  }, [material]);

  if (loading) return <CircularLoading/>
  return (
    <Box>
      <BackButton sx={{mb: 4}}/>
      <Typography variant={'h2'} sx={{mb: 3}}>
        {material?.title}
      </Typography>
      <Stack direction={'row'} spacing={0.5} sx={{mb: 1.5}}>
        {material?.keywords?.map((k) => <Chip
          key={`keyword-${k.id}`}
          label={k.keyword.title}
          sx={(theme) => ({...theme.typography.caption1})}/>)}
      </Stack>
      <DateText date={material?.publishedAt} sx={{mb: 5}}/>
      <Box sx={(theme) => ({
        px: 2,
        py: 3,
        borderRadius: 5,
        border: '1px solid',
        borderColor: 'grey.100',
      })}>
        <Text text={material?.currentVersion?.text || ''}/>
        {
          material?.files && material.files.length > 0 && (
            <Stack spacing={2}>
              {material.files?.map((file) => <FileItem key={file.id} {...file}/>)}
            </Stack>
          )
        }
      </Box>
    </Box>
  )
}

export default MaterialView;
